import api from "../api";

export const ACTION_TYPES = {
    FETCH_NOTIFICATIONSTATUS : 'FETCH_NOTIFICATIONSTATUS',
    FETCH_NOTIFICATIONDETAIL : 'FETCH_NOTIFICATIONDETAIL',
    FETCH_NOTIFICATIONCHNGSTATUS : 'FETCH_NOTIFICATIONCHNGSTATUS'
}

export const fetch_NotificationStatus = (lang, token, folioOrder, orderNumber, readInd, onError, onSuccess) => dispatch => {
    api.Notifications().fetchNotificationStatus(lang, token, folioOrder, orderNumber, readInd)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_NOTIFICATIONSTATUS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}


export const fetch_NotificationDetail = (lang, token, folioOrder, orderNumber, readInd, onError, onSuccess) => dispatch => {
    api.Notifications().fetchNotificationDetail(lang, token, folioOrder, orderNumber, readInd)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_NOTIFICATIONDETAIL,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_NotificationChngStatus = (lang, token, poId,unitId,notified, userId, onError, onSuccess) => dispatch => {
    api.Notifications().updateNotificationStatus(lang, token, poId,unitId,notified, userId)
    .then(response => {
        dispatch({
            type: ACTION_TYPES.FETCH_NOTIFICATIONCHNGSTATUS,
            payload: response.data
        })
        onSuccess()
    })
    .catch(err => onError(err))
}